
import u from "umbrellajs"

import Input from "./components/input/index"
import IntlTelInput from "plugins/intl_tel_input/index"

const CELL_CLASS_NAME = "cell--mobile-apps--searcher-app--download-link"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    Input.init({main: el})
  })
  IntlTelInput.init()
}

export default {
  init,
}
